module.exports = __webpack_public_path__ + "static/media/sd.9b0974f1.svg";